import { API_BASE } from "./Base";

export { API_BASE };

export const CategoriesAPI = new API_BASE("/Catalogue/Categories");
export const CategoriesByIdAPI = new API_BASE("/Catalogue/CategoriesById");
export const CategoriesGroupAPI = new API_BASE("/Catalogue/CategoryGroups");
export const PageGroupsAPI = new API_BASE("/Core/PageGroups");
export const PageGroupAPI = new API_BASE("/Core/PageGroup");
export const CategoriesFileAPI = new API_BASE("/Catalogue/CategoryFile");
export const FieldSetsAPI = new API_BASE("/Catalogue/FieldSets");
export const CategoryFieldSetsAPI = new API_BASE(
  "/Catalogue/CategoryFieldSets",
);

export const SocialPlatformsGetAPI = new API_BASE("/Catalogue/SocialPlatforms");
export const SocialPlatformsPostAPI = new API_BASE("/Catalogue/SocialPlatform");

export const VariantsAPI = new API_BASE("/Catalogue/Variants");
export const VariantsFilesAPI = new API_BASE("/Catalogue/VariantFiles");
export const CategoryVariantsAPI = new API_BASE("/Catalogue/CategoryVariants");
export const ProductsAPI = new API_BASE("/Catalogue/Products");
export const StoreProductsAPI = new API_BASE("/Catalogue/StoreProducts");

export const MenusAPI = new API_BASE("/Core/Menus");
export const LibraryAPI = new API_BASE("/Core/Library");
export const LibraryWithDetailsAPI = new API_BASE("/Core/LibraryWithDetails");
export const ContactAPI = new API_BASE("/Core/Contact");
export const ContactsAPI = new API_BASE("/Core/Contacts");
export const RolesAPI = new API_BASE("/Administration/Roles");
export const RoleAPI = new API_BASE("/Administration/Role");
export const UsersAPI = new API_BASE("/Administration/Users");
export const UsersRoleAPI = new API_BASE("/Administration/UserRoles");
export const UserRoleByIDAPI = new API_BASE("/Administration/UserRole");
export const UpdateProfileAPI = new API_BASE("/Administration/UpdateProfile");
export const RolePermissionsAPI = new API_BASE(
  "/Administration/RolePermissions",
);
export const ForgetPasswordAPI = new API_BASE("/Authentication/Forgot");
export const ResetPasswordAPI = new API_BASE("/Authentication/ChangePassword");
export const SignUpAPI = new API_BASE("/Authentication/SignUp");
export const InventoryAPI = new API_BASE("/OOH/AdInventory");
export const PagesAPI = new API_BASE("/Core/Pages");
export const EstimatesAPI = new API_BASE("/Core/Estimates");
export const CustomersAPI = new API_BASE("/Core/Customers");
export const CustomerAPI = new API_BASE("/Core/Customer");
export const CustomersEstimatesAPI = new API_BASE("/Core/CustomerEstimates");
export const UpdateEstimatesAPI = new API_BASE("/Core/UpdateEstimates");

export const SettingsAPI = new API_BASE("/Core/GetSettings");
export const UpdateSettingsAPI = new API_BASE("/Core/UpdateSettings");
export const SliderImagesAPI = new API_BASE("/Core/SliderImages");
export const MarqueeMessagesAPI = new API_BASE("/Core/MarqueeMessages");

export const CostCenterAPI = new API_BASE("/Accounting/CostCenter");
export const FiscalYearAPI = new API_BASE("/Accounting/FiscalYear");
export const ChartOfAccountAPI = new API_BASE("/Accounting/ChartOfAccount");
export const FinanceBookAPI = new API_BASE("/Accounting/FinanceBook");
export const SearchAccountAPI = new API_BASE("/Accounting/SearchAccount");
export const VouchersAPI = new API_BASE("/Accounting/Vouchers");
export const VoucherAPI = new API_BASE("/Accounting/Voucher");
export const VouchersPostAPI = new API_BASE("/Accounting/PostVouchers");

export const CompanyAPI = new API_BASE("/Weighment/Company");
export const CompaniesAPI = new API_BASE("/Weighment/Companies");
export const PartiesAPI = new API_BASE("/Weighment/Parties");

export const WeighmentSitesAPI = new API_BASE("/Weighment/WeighmentSites");
export const WeighmentIndicatorsAPI = new API_BASE(
  "/Weighment/WeighmentIndicators",
);

export const EPromotionsAPI = new API_BASE("/Seller/Promotion");
export const EReviewsAPI = new API_BASE("/Ecommerce/Reviews");
export const ECartItemsAPI = new API_BASE("/Ecommerce/CartItems");
export const EWishListAPI = new API_BASE("/Ecommerce/WishList");

// ==========================FBR=================================
export const DISellersAPI = new API_BASE("/DI/DISellers");
export const FBRSingleDigitalInvoiceAPI = new API_BASE("/DI/DigitalInvoice");
export const FBRDigitalInvoicesAPI = new API_BASE("/DI/DigitalInvoices");

export const FBRDigitalInvoicePostAPI = new API_BASE("/DI/PushToFBR");

export const ValidateFromFBRAPI = new API_BASE("/DI/ValidateFromFBR");

export const SellersAPI = new API_BASE("/Seller/Sellers");
export const StoresAPI = new API_BASE("/Seller/Stores");
export const WarehousesAPI = new API_BASE("/Seller/Warehouses");
export const BanksAPI = new API_BASE("/Seller/Banks");

export const ProductCustomizationAPI = new API_BASE(
  "/Site/ProductCustomization",
);
export const FieldSetsByCategoryAPI = new API_BASE(
  "/Catalogue/FieldSetsByCategory",
);
